import * as React from "react";

const SvgRightButton = ({ color, ...props }) => (
  <svg
    width="55"
    height="55"
    viewBox="0 0 55 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="54.3483"
      y="54.4531"
      width="54"
      height="54"
      rx="27"
      transform="rotate(180 54.3483 54.4531)"
      fill={color}
    />
    <path
      d="M22.8483 37.4531L31.2462 28.1221C31.5885 27.7418 31.5885 27.1645 31.2462 26.7842L22.8483 17.4531"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgRightButton;
